module.exports = __webpack_public_path__ + "img/coach-badge.5bf75d3f.svg";